import React from 'react'

const IconChevronDownXs = ({
  className = '',
  strokeWidth = '1'
}: {
  className?: string
  strokeWidth?: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeWidth={strokeWidth}
        stroke="currentColor"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.64645 5.85644C3.84171 5.66118 4.15829 5.66118 4.35355 5.85644L8 9.50288L11.6464 5.85644C11.8417 5.66118 12.1583 5.66118 12.3536 5.85644C12.5488 6.0517 12.5488 6.36828 12.3536 6.56354L8.35355 10.5635C8.15829 10.7588 7.84171 10.7588 7.64645 10.5635L3.64645 6.56355C3.45118 6.36828 3.45118 6.0517 3.64645 5.85644Z"
      />
    </svg>
  )
}

export default IconChevronDownXs
